import { render, staticRenderFns } from "./myCollectQA.vue?vue&type=template&id=1e0e4390&scoped=true&"
import script from "./myCollectQA.vue?vue&type=script&lang=ts&"
export * from "./myCollectQA.vue?vue&type=script&lang=ts&"
import style0 from "./myCollectQA.vue?vue&type=style&index=0&id=1e0e4390&lang=less&scoped=true&"
import style1 from "./myCollectQA.vue?vue&type=style&index=1&id=1e0e4390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e4390",
  null
  
)

export default component.exports